var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BookModel } from "..";
import { normalizeField } from "../../../components/BookingFormPage/field-meta";
import set from "lodash/set";
import get from "lodash/get";
import { isValidationDisabled } from "../../../components/BookingForm/booking-form.helpers";
var ConsentModel = /** @class */ (function (_super) {
    __extends(ConsentModel, _super);
    function ConsentModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConsentModel.prototype.getTableName = function () {
        return this.get("table_name");
    };
    ConsentModel.prototype.getItemName = function () {
        return this.get("name");
    };
    ConsentModel.prototype.getField = function (form, validationErrors, _a) {
        var _b;
        var _c = _a === void 0 ? {} : _a, _d = _c.prefix, prefix = _d === void 0 ? "" : _d;
        var url = this.get("url");
        var fieldName = [prefix, this.getItemName()].filter(Boolean).join(".");
        var title = !url ? this.get("website_title") : "<a href=\"" + url + "\" target=\"_blank\" rel=\"noopener\" />" + this.get("website_title") + "</a>";
        var defaultValue = !!this.get("default_value");
        var enableConsent = !this.options.isAdminIntegration || !!form.hasCoworkerConsent;
        var checked = (_b = get(form, fieldName)) !== null && _b !== void 0 ? _b : defaultValue;
        var field = normalizeField({
            field_type_name: "checkbox",
            children: this.get("description"),
            is_required: !!this.get("is_required") && enableConsent,
            name: fieldName,
            title: title,
        }, {
            key: fieldName + enableConsent,
            disabled: !enableConsent,
            recommended: this.get("is_recommended"),
            checked: checked,
            defaultValue: checked,
            initialValue: checked,
            clearedValue: false,
            disableValidation: isValidationDisabled(form)
        });
        if (validationErrors) {
            var errorFieldName = fieldName.replace("form_data.", "");
            var billErrorFieldName = errorFieldName.replace("personal_data", "bill");
            set(field, "error_message", (validationErrors[billErrorFieldName] || validationErrors[errorFieldName] || [])[0]);
        }
        return field;
    };
    return ConsentModel;
}(BookModel));
export { ConsentModel };
